var map = {
	"./train_bg_2.png": 736,
	"./train_bg_2_2.png": 737,
	"./train_bg_2_3.png": 738,
	"./train_bg_2_4.png": 739,
	"./train_bg_2_5.png": 740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1865;